import AUTH_BASE_URL from "../AUTH_BASE_URL";

export default async function getUserById (id) {
    return await fetch(`${AUTH_BASE_URL}auth/user/user/${id}`, {
    }).then((response => {
        return response.json()
    })).then((data => {
        return data
    }))
}
